import { requestGet, requestPost } from '@/utils/request';

const api = {
    LIST: '/op/moderate_list',
    PENDING_COUNT: '/op/moderate_pending_count',
    PASSED: '/op/moderate_passed',
    REFUSE: '/op/moderate_refuse',
}

export async function moderateList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function moderatePendingCount() {
    return requestGet(api.PENDING_COUNT);
}

export async function moderatePassed(ids) {
    let params = {ids: ids};
    return requestPost(api.PASSED, params);
}

export async function moderateRefuse(formData) {
    return requestPost(api.REFUSE, formData);
}